import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseclient';
import * as XLSX from 'xlsx';

export default function Cras2() {
  const [loading, setLoading] = useState(false);
  const [tecnico, setTecnico] = useState('');
  const [atendimentos, setAtendimentos] = useState([]);

  // 1. FUNÇÃO DE BUSCA (Direcionada para CRAS 2)
  const buscarDados = async () => {
    const { data: lista, error } = await supabase
      .from('cras2_atendimentos') 
      .select('*')
      .order('created_at', { ascending: false });
    
    if (!error && lista) setAtendimentos(lista);
  };

  // 2. CARREGAMENTO INICIAL
  useEffect(() => {
    const inicializarPagina = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        const { data: perfil } = await supabase
          .from('perfis')
          .select('nome')
          .eq('id', session.user.id)
          .maybeSingle();
        
        setTecnico(perfil?.nome || "Técnico Não Identificado");
        await buscarDados();
      }
    };
    inicializarPagina();
  }, []);

  // 3. FUNÇÃO PARA EXPORTAR EXCEL
  const handleExportarExcel = () => {
    if (atendimentos.length === 0) {
      alert("Não há dados para exportar.");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(atendimentos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Atendimentos");
    XLSX.writeFile(wb, `Atendimentos_CRAS_2_Mirassol.xlsx`);
  };

  // 4. LÓGICA DE SALVAMENTO
  const handleSalvar = async (e) => {
    e.preventDefault();
    setLoading(true);

    const fd = new FormData(e.target);
    const dadosForm = Object.fromEntries(fd);

    const payload = {
      ...dadosForm,
      tecnico_responsavel: tecnico,
      created_at: new Date().toISOString()
    };

    try {
      const { error } = await supabase.from('cras2_atendimentos').insert([payload]);
      if (error) throw error;

      alert("✅ Atendimento no CRAS 2 registrado com sucesso!");
      e.target.reset();
      await buscarDados(); 
    } catch (error) {
      alert("❌ Erro ao salvar: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      {/* CARD DO FORMULÁRIO COM TEMA VERDE */}
      <div className="bg-white p-8 rounded-[2.5rem] shadow-2xl border border-gray-100">
        
        <header className="flex flex-col md:flex-row md:items-center justify-between border-b pb-6 mb-8 gap-4">
          <div>
            <h2 className="text-3xl font-black text-green-900 uppercase tracking-tighter">🏠 Unidade CRAS II</h2>
            <p className="text-xs font-bold text-green-600 uppercase tracking-widest mt-1">Registro de Atendimento Socioassistencial</p>
          </div>
          <div className="bg-green-50 px-6 py-3 rounded-2xl border border-green-100">
            <p className="text-[10px] font-black text-green-400 uppercase">Técnico Responsável</p>
            <p className="text-sm font-black text-green-900 uppercase">{tecnico || "Carregando..."}</p>
          </div>
        </header>

        <form onSubmit={handleSalvar} className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="md:col-span-2">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 block">Nome do Munícipe</label>
            <input name="nome_municipe" required className="input-field" placeholder="Nome completo" />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 block">CPF / NIS</label>
            <input name="cpf" className="input-field" placeholder="000.000.000-00" />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 block">Telefone</label>
            <input name="telefone" className="input-field" placeholder="(17) 00000-0000" />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 block">Tipo de Demanda</label>
            <select name="tipo_demanda" className="input-field" required>
              <option value="">Selecione...</option>
              <option value="PAIF">Acompanhamento PAIF</option>
              <option value="CADUNICO">CadÚnico</option>
              <option value="BENEFICIO_EVENTUAL">Benefício Eventual</option>
              <option value="VISITA">Visita Domiciliar</option>
            </select>
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 block">NIS (Opcional)</label>
            <input name="nis" className="input-field" placeholder="Número NIS" />
          </div>

          <div className="md:col-span-3">
            <label className="text-[10px] font-black text-gray-400 uppercase ml-1 mb-1 block">Evolução do Atendimento</label>
            <textarea name="evolucao" rows="4" required className="input-field resize-none" placeholder="Relato técnico detalhado..."></textarea>
          </div>

          <button 
            disabled={loading}
            className="md:col-span-3 bg-green-700 text-white font-black py-5 rounded-2xl shadow-xl hover:bg-green-800 transition-all active:scale-95 text-lg"
          >
            {loading ? "SALVANDO NO BANCO..." : "✅ REGISTRAR NO CRAS II"}
          </button>
        </form>

        {/* TABELA DE HISTÓRICO */}
        <div className="mt-12 border-t pt-8">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-black text-green-900 uppercase">📋 Histórico Recente CRAS II</h3>
            <button 
              onClick={handleExportarExcel}
              className="bg-emerald-600 hover:bg-emerald-700 text-white text-[10px] font-black uppercase px-4 py-2 rounded-xl flex items-center gap-2 shadow-lg transition-all"
            >
              📊 Exportar Excel
            </button>
          </div>
          
          <div className="overflow-hidden rounded-2xl border border-gray-100">
            <table className="w-full text-left">
              <thead className="bg-gray-50 text-[10px] font-black text-gray-400 uppercase">
                <tr>
                  <th className="p-4">Data</th>
                  <th className="p-4">Munícipe</th>
                  <th className="p-4">Demanda</th>
                  <th className="p-4">Técnico</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {atendimentos.map((atend) => (
                  <tr key={atend.id} className="hover:bg-green-50/30 transition-colors">
                    <td className="p-4 text-xs font-bold text-gray-500">
                      {new Date(atend.created_at).toLocaleDateString('pt-BR')}
                    </td>
                    <td className="p-4">
                      <p className="text-sm font-black text-gray-800 uppercase">{atend.nome_municipe}</p>
                    </td>
                    <td className="p-4">
                      <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-[9px] font-black uppercase">
                        {atend.tipo_demanda}
                      </span>
                    </td>
                    <td className="p-4 text-[10px] font-bold text-gray-400 uppercase">
                      {atend.tecnico_responsavel}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
